/**
 * BottomBar.js
 *
 * A minimal, elegant footer for a personal portfolio website.
 *
 * 🧭 Layout:
 * - Left  → Navigation links (About, Work, Contact)
 * - Right → Contact section (“Get In Touch”) and Socials (LinkedIn, GitHub, Email)
 *
 * 🎨 Design Philosophy:
 * Inspired by Apple and minimalist UX principles:
 * - Clear typographic hierarchy using small, subtle text.
 * - Balanced whitespace for visual calm.
 * - No brand repetition — the design speaks for itself.
 * - Fully responsive: stacks vertically on mobile, horizontal grid on desktop.
 *
 * 🧩 Accessibility:
 * - Semantic HTML structure with <nav> and <footer>.
 * - Keyboard focus visible on all links.
 * - ARIA labels on icons.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import Github from "../../assets/Logos/github-mark.svg"
import LinkedIn from "../../assets/Logos/linkedin-logo.svg"
import Instagram from "../../assets/Logos/Instagram_logo_2022.svg.png"

const BottomBar = () => {
    const navigate = useNavigate();

    return (
        <footer
            className="
                w-full border-t border-zinc-800
                bg-zinc-950
                text-zinc-400
                text-sm
                px-6 lg:px-20 py-10
                flex flex-col lg:flex-row justify-between gap-10
                transition-colors duration-500
            "
        >
            {/* ---------------- Left Section: Navigation ---------------- */}
            <nav
                aria-label="Footer Navigation"
                className="
                    flex flex-col gap-2
                    text-xs sm:text-sm
                "
            >
                <button
                    onClick={() => navigate("/about")}
                    className="w-fit hover:text-white transition-colors"
                >
                    About
                </button>
                <button
                    onClick={() => navigate("/work")}
                    className="w-fit hover:text-white transition-colors"
                >
                    Work
                </button>
                <button
                    onClick={() => navigate("/contact")}
                    className="w-fit hover:text-white transition-colors"
                >
                    Contact
                </button>
            </nav>

            {/* ---------------- Right Section: Contact & Socials ---------------- */}
            <div className="flex flex-col gap-6 text-xs sm:text-sm">
                {/* Get In Touch Section */}
                <div>
                    <h3 className="font-medium text-zinc-100 mb-2">
                        Get In Touch
                    </h3>
                    <div className="flex flex-col gap-1">
                        <a
                            href="mailto:yash301020@gmail.com"
                            className="hover:text-white transition-colors"
                        >
                            yash301020@gmail.com
                        </a>
                        <a
                            href="tel:+918448490819"
                            className="hover:text-white transition-colors"
                        >
                            +91 9810060918
                        </a>
                    </div>
                </div>

                {/* Social Links Section */}
                <div>
                    <h3 className="font-medium text-zinc-100 mb-2">
                        Socials
                    </h3>
                    <div className="flex items-center justify-center gap-2">
                        <a
                            href="https://www.linkedin.com/in/yashjain-trainrex/"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="LinkedIn"
                            className="hover:text-white transition-colors"
                        >
                            <img src={LinkedIn} alt="g" className="w-6 fill-white"/>
                        </a>
                        <a
                            href="https://github.com/yashjain-10"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="GitHub"
                            className="hover:text-white transition-colors"
                        >
                            <img src={Github} alt="g" className="w-6 fill-white"/>
                        </a> 
                        <a
                            href="https://www.instagram.com/isayyashtothat/"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="GitHub"
                            className="hover:text-white transition-colors"
                        >
                            <img src={Instagram} alt="g" className="w-6 fill-white"/>
                        </a> 
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default BottomBar;